import React from "react";
import SectionHeader from "./SectionHeader";
import { routingInformation } from "./constant";
import { useLocation } from "react-router-dom";

function RoutingInformation({
  expandedSections,
  onChange = () => {},
  toggleSection,
  formData,
  labelClass,
  inputClass,
  selectClass,
}) {
  const location = useLocation();
  const data = location.state || {};
 
  return (
    <div className="rounded border border-slate-200 dark:border-slate-700 overflow-hidden">
  
     
        <div className="p-4">
          <div className="grid grid-cols-4 gap-4">
            {routingInformation &&
              routingInformation.map((field, index) => {
                return (
                  <div key={"routing" + index}>
                    <label className={labelClass}>{field?.label}</label>
                    {field.type === "select" ? (
                      <select
                        name={field?.name}
                        className={selectClass}
                        value={data?.[field?.name]}
                        disabled={field?.disabled}
                      >
                        {field?.options &&
                          field?.options?.map((option, i) => (
                            <option key={field?.name + i} value={option?.value}>
                              {option?.label}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <input
                        name={field?.name}
                        type="text"
                        className={inputClass}
                        disabled={field?.disabled}
                        value={data?.[field?.name]}
                      />
                    )}
                  </div>
                );
              })}

            <div>
              <label className={labelClass}>Loading Pier / Terminal:</label>
              <input
                name={"loadingpierterminal"}
                type="text"
                className={inputClass}
                value={formData?.loadingpierterminal}
                onChange={(e) =>
                  onChange("loadingpierterminal", e.target.value, "text")
                }
              />
            </div>
          </div>
        </div>
    
    </div>
  );
}

export default RoutingInformation;
